import React from 'react';
import * as PropTypes from 'prop-types';
import { Button, Card } from '@snsw/react-component-library';
import { Link } from 'react-router-dom';
import moment from 'moment';
import styled from 'styled-components';

const WrappedCard = styled.div`
    margin-top: 0.75rem;
    border: solid grey 2px;
    width: 100%;

    @media (max-width: 576px) {
        width: 100%;
        overflow-y: scroll;
        height: auto !important;
    }

    p {
        b {
            display: inline-block;
            min-width: 12rem;
        }
    }
`;

export const BusinessDetailsDisplay = props => {
    const business = props.business;

    return (<>
        {business && business.abn && <WrappedCard><Card
            className='business-details-card'
            height='100%'
            loading={ false }
            title=''
            vertical={ false }
            style={
                { backgroundColor: '#e6f0f3' }
            }
        >

            <p><b>ABN:</b> { business.abn || 'Not set'} <br /></p>
            <p><b>Business name:</b>
                <span> { business.businessName || 'Not set' }</span>
                <br />
            </p>
            <p><b>Entity name:</b> { business.entityName || 'Not set'} <br /></p>
            <p><b>Entity type:</b> { business.entityDescription || 'Not set'} <br /></p>
            <p><b>Main location:</b> { business.abnLocation?.postCode ? `${business.abnLocation?.postCode} ${business.abnLocation?.stateCode}` : 'Not set' } <br /></p>
            <p><b>ABN status:</b> { business.abnEntityStatusCode || 'Not set'} <br /></p>
            <p><b>ABN effective from:</b> { moment(business.abnEffectiveFrom).format('YYYY-MM-DD') || 'Not set'} <br /></p>
            <p><b>GST status:</b> { business.abnGstStatus?.status || 'Not registered for GST' } <br /></p>

            { props.onClearRequest && <Button
                onClick={ props.onClearRequest }
                as={ Link }
                theme='link'
                size='small'
            >
                Remove business details
            </Button>}

        </Card></WrappedCard>}
    </>);};

BusinessDetailsDisplay.propTypes = {
    business: PropTypes.object.isRequired,
    onClearRequest: PropTypes.func
};

